import React, { useMemo, useCallback } from 'react';
import {useSelector } from 'react-redux';
import DropdownVoucherDynamicInput from '../../../../components/Dropdown/DropdownVoucherDynamicInput';

export const VoucherContraInputRow = ({
  valueLoop,
  setValueLoop,
  showBorder,
  handleChange,
  handleFocus,
  handleBlur,
  inputRefs,
  dropList,
  narr_ref,
  handleDropdownDynamicClick
}) => {
  const modal_state = useSelector(state => state.common.modal_state);

  // Memoize the input handlers
  const getInputHandlers = useCallback((index, field) => ({
    onChange: (e) => handleChange(e, index, field, e.target.value),
    onKeyUp: (e) => handleChange(e, index, field, e.target.value),
    onFocus: (e) => handleFocus(e, index, field, e.target.value),
    onBlur: (e) => handleBlur(e, index, field, e.target.value)
  }), [handleChange, handleFocus, handleBlur]);

  // Memoize balance display calculation
  const shouldShowBalance = useCallback((item) => {
    return item?.first !== '' &&
      item?.particular_ledger_balance !== '' &&
      item?.particular_ledger_balance !== '0' &&
      item?.particular_ledger_balance !== 0 &&
      item?.first !== 'End of List';
  }, []);

  // Memoize balance class and text
  const getBalanceDisplay = useCallback((balance) => {
    const balanceNum = parseFloat(balance);
    return {
      className: balanceNum < 0 ? 'color_red' : 'text-muted',
      suffix: balance === 0 ? '' : balanceNum < 0 ? ' Cr' : ' Dr'
    };
  }, []);

  return (
    <div className='row p-0 m-0 mb-1'>
      {valueLoop?.data?.map((item, index) => {
        const firstInputHandlers = getInputHandlers(index, 'first');
        const amountInputHandlers = getInputHandlers(index, 'particular_ledger_pay_amount');
        const balanceDisplay = getBalanceDisplay(item?.particular_ledger_balance);
        
        return (
          <div
            key={index}
            className={`col-12 ${showBorder ? 'border-bottom border-dark' : ''}`}
            style={{ height: 40, backgroundColor: 'transparent' }}
          >
            <div className='row' style={{ height: 40 }}>
              <div className='col-4 m-0 p-0 container_of_voucher_input'>
                <input
                  type='text'
                  name={`first_${index}`}
                  ref={el => { inputRefs.current[`first${index}`] = el }}
                  className='voucher_entry_account_input'
                  value={item?.first || ''}
                  {...firstInputHandlers}
                />
              </div>

              {modal_state[`first${index}`] && (
                <DropdownVoucherDynamicInput
                  title={'List of Ledger Account'}
                  state={modal_state[`first${index}`]}
                  data={valueLoop}
                  setData={setValueLoop}
                  input_value={item?.first}
                  input_key={'first'}
                  input_id={'particular_ledger_id'}
                  input_blc={'particular_ledger_balance'}
                  rawData={dropList}
                  index={index}
                  ref={inputRefs.current[`first${index}`]}
                  refs={inputRefs}
                  narr_ref={narr_ref}
                  isDynamic={true}
                  handleDropdownClick={handleDropdownDynamicClick}
                />
              )}

              <div className='col-6' />

              <div className='col-2 m-0 p-0 container_of_voucher_input'>
                {item?.first !== 'End of List' && (
                  <input
                    type='text'
                    style={{ textAlign: 'right', paddingRight: 5 }}
                    name={`particular_ledger_pay_amount_${index}`}
                    ref={el => { inputRefs.current[`particular_ledger_pay_amount${index}`] = el }}
                    className='voucher_entry_account_input'
                    value={item?.particular_ledger_pay_amount || ''}
                    {...amountInputHandlers}
                  />
                )}
              </div>

              <div className='col-6 m-0 ms-5'>
                {shouldShowBalance(item) && (
                  <div className='row' style={{ height: 19.5 }}>
                    <div className='col-1 p-0 m-0 font_size' style={{ textAlign: 'left', width: '8.5%' }}>
                      Cur Bal:
                    </div>
                    <div className='col-2 m-0 p-0 font_size' style={{ textAlign: 'right', height: 19.5 }}>
                      <span className={balanceDisplay.className}>
                        {item?.particular_ledger_balance}
                      </span>
                    </div>
                    <div className='col-2 m-0 p-0 ps-1 font_size' style={{ textAlign: 'left', height: 19.5 }}>
                      <span className={balanceDisplay.className}>
                        {balanceDisplay.suffix}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};